import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DocumentComponent } from './document.component';
import { Location, ViewportScroller } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FavoriteService,
  AnalyticsService,
  AuthService,
  FeatureFlagService,
  PostHogService
} from '@icullen/api/shared';
import { OurTeamApiService } from '@icullen/api/document';
import { TopicsService } from '@icullen/api/site';
import { ResetDocumentTabEventService } from './reset-document-tab-event.service';

@Component({
  selector: 'document-mobile',
  templateUrl: './document-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./document-mobile.component.scss'],
})
export class DocumentMobileComponent
  extends DocumentComponent
  implements OnInit
{
  activeAccordeon: string;
  mobileOtherVersionsAreOpen = false;

  constructor(
      router: Router,
      activatedRoute: ActivatedRoute,
      favoriteService: FavoriteService,
      analyticsService: AnalyticsService,
      authService: AuthService,
      cdr: ChangeDetectorRef,
      topicsService: TopicsService,
      viewportScroller: ViewportScroller,
      private location: Location,
      private resetDocumentTabService: ResetDocumentTabEventService,
      private postHogService: PostHogService,
      featureFlagService: FeatureFlagService
    ) {
      super(
        router,
        activatedRoute,
        favoriteService,
        analyticsService,
        authService,
        topicsService,
        cdr,
        featureFlagService,
        viewportScroller
      );
    }

  ngOnInit(): void {
    super.ngOnInit();
    this.setActiveAccordeon();
  }

  showAccordeonOnClick(clickedaccordeon: string) {
    this.activeAccordeon = clickedaccordeon;
  }

  setActiveAccordeon() {
    if (this.docData.versions.length > 0) {
      this.activeAccordeon = this.docData.versions[0];
    }
  }

  goBack() {
    this.location.back();
  }

  disableScrolling() {
    const x = window.scrollX;
    const y = window.scrollY;
    window.onscroll = function () {
      window.scrollTo(x, y);
    };
  }

  enableScrolling() {
    window.onscroll = function () {};
  }

  openMobileOtherVersionsOnClick() {
    this.mobileOtherVersionsAreOpen = true;
    this.disableScrolling();
  }

  closeMobileOtherVersionsOnClick() {
    this.mobileOtherVersionsAreOpen = false;
    this.enableScrolling();
  }
}
